export enum Currency {
  EUR = 'EUR',
  DKK = 'DKK',
  SEK = 'SEK',
  NOK = 'NOK',
  ISK = 'ISK',
  GBP = 'GBP',
  CHF = 'CHF',
  PLN = 'PLN',
  CZK = 'CZK',
  HUF = 'HUF',
  RON = 'RON',
  BGN = 'BGN',
  RSD = 'RSD',
  ALL = 'ALL',
  BAM = 'BAM',
  MKD = 'MKD',
  MDL = 'MDL',
  UAH = 'UAH',
  BYN = 'BYN',
  TRY = 'TRY',
  USD = 'USD',
  CAD = 'CAD',
}

export const CURRENCY_NAMES: Record<Currency, string> = {
  [Currency.EUR]: 'Euro',
  [Currency.DKK]: 'Danish Krone',
  [Currency.SEK]: 'Swedish Krona',
  [Currency.NOK]: 'Norwegian Krone',
  [Currency.ISK]: 'Icelandic Krona',
  [Currency.GBP]: 'British Pound',
  [Currency.CHF]: 'Swiss Franc',
  [Currency.PLN]: 'Polish Zloty',
  [Currency.CZK]: 'Czech Koruna',
  [Currency.HUF]: 'Hungarian Forint',
  [Currency.RON]: 'Romanian Leu',
  [Currency.BGN]: 'Bulgarian Lev',
  [Currency.RSD]: 'Serbian Dinar',
  [Currency.ALL]: 'Albanian Lek',
  [Currency.BAM]: 'Bosnia-Herzegovina Mark',
  [Currency.MKD]: 'North Macedonian Denar',
  [Currency.MDL]: 'Moldovan Leu',
  [Currency.UAH]: 'Ukrainian Hryvnia',
  [Currency.BYN]: 'Belarusian Ruble',
  [Currency.TRY]: 'Turkish Lira',
  [Currency.USD]: 'US Dollar',
  [Currency.CAD]: 'Canadian Dollar',
}
